"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 4
    },
    overlay: {
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 4 + 1,
        backgroundColor: globalStyle_1.default.grey3,
        opacity: 0.2
    },
    prompt: {
        zIndex: 4 + 2,
        backgroundColor: 'white'
    },
    body: {
        padding: '20px'
    },
    title: {
        padding: '20px',
        borderBottom: 'solid 1px black'
    }
};
//# sourceMappingURL=dialog.style.js.map